var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.header,{tag:"Component",attrs:{"props":_vm.props}})
}
var staticRenderFns = []

export { render, staticRenderFns }